export { DarkIncidentsTable } from './DarkIncidentsTable'
